/**
 * Tendril view-route registry.
 *
 * Maps logical route names (declared in tendril.capabilities.yaml view
 * capabilities) to React Router path patterns.
 *
 * Usage: `viewRouteRegistry['workshop-detail']` → `/workshops/:workshopId`
 *
 * Kept as a plain module-local object for zero-overhead lookup. The CI
 * cross-check test in tests/lib/tendril-view-route-registry.test.js
 * verifies every view capability's route has an entry here.
 *
 * When adding a new view capability:
 *   1. Add a route entry here (logical-name → React Router path)
 *   2. The CI test will pass on the next run
 */

/** @type {Record<string, string>} */
const viewRouteRegistry = {
  /** Navigate to a specific workshop's detail page */
  'workshop-detail': '/workshops/:workshopId',

  /** Navigate to the user's workshop enrollment list */
  'my-enrollments': '/workshops',
};

export default viewRouteRegistry;
